<template>
    <div class="d-flex justify-content-between">
        <div>
            <div class="display-4">
                <span v-if="is_time(valor)">
                    {{ $util.minutes2time(valor) }}
                </span>
                <span v-else-if="is_money(valor) || is_formula">
                    {{ $util.formatMoeda(valor) }}
                </span>
                <span v-else>
                    {{ valor }}
                </span>
            </div>
            <div class="text-muted" v-if="config">
                {{ config.unidade_de_medida }}
            </div>
        </div>
        <div>
            <i class="fa-4x" :class="config.icone" v-if="config && config.icone"></i>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    props: ['relatorio', 'config', 'query', 'is_formula', 'dados'],

    computed: { 
        valor: function () { 
            if ( this.is_formula ) {

                let formula = this.config.formula || "";

                if ( !formula ) { 
                    return ""; 
                }

                // Localicar #(n) e substituir pelo valor da consulta no relatório
                const regex = /#(\d+)/g;

                console.log("formula:", formula);

                let match;
                while ((match = regex.exec(formula)) !== null) {
                    console.log("Match found:", match);
                    const queryId = match[1];
                    const ref_id = this.get_ref_id(queryId);
                    const kpiComponent = this.$parent.$refs['kpi' + ref_id];
                    let kpiValue = 0;
                    if (kpiComponent && kpiComponent.length > 0) {
                        kpiValue = kpiComponent[0].valor;
                    }
                    formula = formula.replace(match[0], kpiValue);
                }

                try {
                    const resultado = Function(`"use strict"; return (${formula})`)();
                    return resultado;
                } catch (error) {
                    console.error("Error evaluating formula:", formula, error);
                    return ""; 
                }
                
                //const resultado = Function(`"use strict"; return (${formula})`)();
                //return resultado;
            }

            let dados = ( this.relatorio && this.relatorio.result && this.relatorio.result.data ) 
                ? this.relatorio.result.data
                : [];

            if ( this.config.filtros ) {
                dados = dados.filter(item => { 
                    return this.config.filtros.every(filtro => { 
                        return filtro.campo 
                            && filtro.campo.column_name
                            && item[filtro.campo.column_name] == filtro.valor;
                    });
                });
            }

            if ( dados.length == 1 ) {

                if ( this.config.colunas ) {
                    return dados[0][this.config.colunas];
                } else { 
                    return _.values(dados[0])[0];
                }

            } else if ( dados.length > 1 ) {

                if ( this.config.colunas ) {

                    let maximo = null;
                    let numerador = null;
                    let denominador = null;

                    switch ( this.config.operacao ) {
                        case 'avg':
                            if ( !dados.length )
                                return 0;

                            numerador = dados.reduce((total, carry) => { 
                                        return total + parseFloat(carry[this.config.colunas]);
                                    }, 0);

                            if ( this.config['operacao-den'] ) { 
                                
                                denominador = _.uniq(
                                    dados.map((carry) => { 
                                        return carry[this.config['operacao-den']];
                                    })
                                ).length;

                            } else {

                                denominador = dados.length;

                            }

                            return denominador != 0 ? numerador / denominador : 0;

                        case 'rel':
                            numerador = dados.reduce((total, carry) => { 
                                return total + parseFloat(carry[this.config.colunas]);
                            }, 0); 

                            denominador = dados.reduce((total, carry) => { 
                                return total + parseFloat(carry[this.config['operacao-den']]);
                            }, 0);

                            return denominador != 0 ? numerador / denominador : 0;

                        case 'max':
                            return dados.reduce((max, carry) => { 
                                return Math.max(max, parseFloat(carry[this.config.colunas]));
                            }, 0);

                        case 'min':
                            maximo = dados.reduce((max, carry) => { 
                                return Math.max(max, parseFloat(carry[this.config.colunas]));
                            }, 0);

                            return dados.reduce((min, carry) => { 
                                return Math.min(min, parseFloat(carry[this.config.colunas]));
                            }, maximo);
                    
                        default:
                            return dados.reduce((total, carry) => { 
                                return total + parseFloat(carry[this.config.colunas]);
                            }, 0);
                    }

                    
                }

            }

            return "";
        },

        ref_tempo:function () { 
            if ( this.config && this.config.tempo && this.config.tempo.quantidade ) { 
                return '_' + this.config.tempo.ref + '_' + this.config.tempo.quantidade + '_' + this.config.tempo.unidade;
            } else { 
                return '';
            }
        },
    },

    methods: {

        get_ref_id (index) { 
            if ( this.dados && this.dados.dashboard_items && this.dados.dashboard_items[index - 1] ) {
                return this.dados.dashboard_items[index - 1].id;
            }

            return null; 
        },

        is_money(valor) {

            if ( isNaN(valor) || this.is_formula ) {
                return false;
            }

            if(this.config.unidade_de_medida && this.config.unidade_de_medida.indexOf('$') >= 0) {
                return true
            } else {

                try {

                    const columns = this.query.config.columns;
                    const column = columns.find(column => column.column_name == this.config.colunas)

                    if(column.format == 'money') {
                        return true;
                    }

                    return false;
                    
                }catch(error) {
                    console.log(error)
                    return false;
                }

                
            }
            
        },

        is_time(valor) {

            if ( isNaN(valor) || this.is_formula ) {
                return false;
            }

            try {

                const columns = this.query.config.columns;
                const column = columns.find(column => column.column_name == this.config.colunas)

                if(column.format == 'min2time') {
                    return true;
                }

                return false;
                
            }catch(error) {
                console.log(error)
                return false;
            }
            
        },

    }

}
</script>